/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorMessage,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
} from '../models/ErrorMessage';
import {
    type TerminalDiagnosisResponse,
    TerminalDiagnosisResponseFromJSON,
    TerminalDiagnosisResponseToJSON,
} from '../models/TerminalDiagnosisResponse';

export interface DiagnoseTerminalRequest {
    locationId: number;
    pspTerminalId: string;
}

export interface DiagnoseTerminalInhouseRequest {
    pspTerminalId: string;
}

/**
 * 
 */
export class TerminalDiagnosisControllerApi extends runtime.BaseAPI {

    /**
     * Creates request options for diagnoseTerminal without sending the request
     */
    async diagnoseTerminalRequestOpts(requestParameters: DiagnoseTerminalRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['locationId'] == null) {
            throw new runtime.RequiredError(
                'locationId',
                'Required parameter "locationId" was null or undefined when calling diagnoseTerminal().'
            );
        }

        if (requestParameters['pspTerminalId'] == null) {
            throw new runtime.RequiredError(
                'pspTerminalId',
                'Required parameter "pspTerminalId" was null or undefined when calling diagnoseTerminal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/client/locations/{locationId}/terminals/{pspTerminalId}/diagnose`;
        urlPath = urlPath.replace('{locationId}', encodeURIComponent(String(requestParameters['locationId'])));
        urlPath = urlPath.replace('{pspTerminalId}', encodeURIComponent(String(requestParameters['pspTerminalId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async diagnoseTerminalRaw(requestParameters: DiagnoseTerminalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminalDiagnosisResponse>> {
        const requestOptions = await this.diagnoseTerminalRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalDiagnosisResponseFromJSON(jsonValue));
    }

    /**
     */
    async diagnoseTerminal(requestParameters: DiagnoseTerminalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminalDiagnosisResponse> {
        const response = await this.diagnoseTerminalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for diagnoseTerminalInhouse without sending the request
     */
    async diagnoseTerminalInhouseRequestOpts(requestParameters: DiagnoseTerminalInhouseRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pspTerminalId'] == null) {
            throw new runtime.RequiredError(
                'pspTerminalId',
                'Required parameter "pspTerminalId" was null or undefined when calling diagnoseTerminalInhouse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Key"] = await this.configuration.apiKey("X-API-Key"); // X-API-Key authentication
        }


        let urlPath = `/v1/inhouse/terminals/{pspTerminalId}/diagnose`;
        urlPath = urlPath.replace('{pspTerminalId}', encodeURIComponent(String(requestParameters['pspTerminalId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async diagnoseTerminalInhouseRaw(requestParameters: DiagnoseTerminalInhouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TerminalDiagnosisResponse>> {
        const requestOptions = await this.diagnoseTerminalInhouseRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TerminalDiagnosisResponseFromJSON(jsonValue));
    }

    /**
     */
    async diagnoseTerminalInhouse(requestParameters: DiagnoseTerminalInhouseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TerminalDiagnosisResponse> {
        const response = await this.diagnoseTerminalInhouseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
